import notify from 'devextreme/ui/notify'
export interface RunQueue {
  analyzer_id: number | null
  status: string | null
  result_id: number | null
  startDate: string | undefined
  endDate: string | undefined
  searchColumn: string
  offset: number | null
  max: number | null
}

export interface Organization {
  id: number
  name: string | null
}

export interface Reviewer {
  id: number
  username: string | null
  reviewMessage: string | null
}

export interface Analyzer {
  id: number
  name: string
  dateCreated: string | null
  lastUpdated: string | null
  user: User
}

export interface Script {
  id: string
  name: string
  filename: string | null
  description: string | null
  created_at: string
  updated_at: string
  approved: boolean
  organization: Organization
  user_id: User
  username: string | null
  reviewer: Reviewer
  type: string
}

export interface RunQueueFilters {
  analyzer_id: number | null
  status: string | undefined
  start: string | number | Date | undefined
  end: string | number | Date | undefined
  searchColumn: string
  offset: number | null
  max: number | null
}

export interface ResultsSearchFilters {
  startDate: string | null
  endDate: string | null
  analyzerId: number[] | null
  analysisScriptId: number[] | null
  names: string[] | null
  fleetId: number[] | null
  vehicleId: number[] | null
  offset: number
  sharedType: number | null
}
type Permissions = {
  IPA: {
    r: boolean
    w: boolean
  }
}

type Preferences = {
  timezone: {
    id: number
    val: string
  }
}
export interface User {
  id: number
  username: string
  firstName?: string
  lastName?: string
  email: string
  administrator?: boolean
  organizations?: Array<Organization>
  organizationAdministrator?: Array<number>
  ldapUser?: boolean
  permissions?: Permissions
  ipa?: boolean
  preferences?: Preferences
}

export const showToast = (
  message: string,
  type = 'error',
  displayTime = 1000
): void => {
  notify({
    message,
    type,
    displayTime,
    position: 'center',
    width: function () {
      return window.innerWidth * 0.4
    },
    shading: true,
    shadingColor: 'rgba(0, 0, 0, 0.1)',
    animation: {
      show: { type: 'fade', duration: 300, from: 0, to: 1 },
      hide: { type: 'fade', duration: 300, to: 0 },
    },
  })
}

export const applySortBy: unknown = () =>
  (function () {
    alert('DOES THIS HAPPEN????')
    if (typeof Object.defineProperty === 'function') {
      Object.defineProperty(Array.prototype, 'sortBy', { value: sb })
    }
    //TODO: remove no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(Array.prototype as any).sortBy) {
      (Array.prototype as any).sortBy = sb
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function sb(this: any, f: any) {
      for (let i = this.length; i; ) {
        const o = this[--i]
        this[i] = [].concat(f.call(o, o, i), o)
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.sort(function (a: any, b: any) {
        for (let i = 0, len = a.length; i < len; ++i) {
          if (a[i] != b[i]) return a[i] < b[i] ? -1 : 1
        }
        return 0
      })
      for (let i = this.length; i; ) {
        this[--i] = this[i][this[i].length - 1]
      }
      return this
    }
  })()
